<div class="_expand z-1">
    <!-- close -->
    <div class="flex flex-middle height-100 right wrap flex-justify-end">
        <button class="inline-flex flex-middle flex-justify-center z-1"
                aria-label="Close"
                (click)="toggleVisibility(false)">
            <i class="icon-close"></i>
        </button>
    </div>
    <div class="wrap fill flex flex-middle flex-justify-center">
        <div class="c-4 m-r-0 m-b-0 ">
            <div class="flex flex-middle height-100 flex-justify-end">
                <div class="_inputBox w-12 flex flex-justify-end"
                     (offClick)="toggleVisibility(false)"
                     [offClickOff]="!isVisible"
                     [offClickFilter]="'[pageHeaderMeganavSearchOutlet]'">
                    <input type="text"
                           cy-searchInput
                           [(ngModel)]="term"
                           (keyup)="onInputKeyUp($event)"
                           (focus)="onInputFocus()"
                           class="flex-grow m-r-2 _input"
                           #input
                           [placeholder]="'What are you looking for?' | translate">
                    <button [iconButton]
                            [status]="status"
                            cy-searchbutton
                            #iconOn
                            (click)="goToSearchView()"
                            aria-label="Search"
                            [icon]="'search'"></button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="right pos-relative inline-block">
    <i class="_icon search-icon icon-search cursor-pointer"
       (click)="input.focus()"
       aria-hidden="true"></i>
</div>